import { IYoutubeDataDTO } from '@/api/video/youtube/types/youtube-data.dto';
import { APIConstants } from '@/api/constants/api.constants';

export class YoutubeService {
  static async getYoutubeData(url: string): Promise<IYoutubeDataDTO> {
    return fetch(`${APIConstants.NoEmbed}${url}`)
      .then((response: Response) => response.json())
      .then(responseJson => responseJson as IYoutubeDataDTO);
  }
}
